export default "__VITE_ASSET__CPvFhQ0$__"